<template>
  <v-layout>
    <!-- <pre style="position: absolute; height: 50px; width: 100%; z-index: 20">{{innerHeight}}</pre> -->
    <div
      :style="`height: ${innerHeight}`"
      class="page-banner banner-layout homepage-banner">
      <div class="page-banner-mask" />
      <div class="banner-inner">
        <h1><span class="icon-logo-letters"/>Ingalls Image</h1>
        <h2>Dream, Design, Do</h2>
        <p>Your one stop shop for your design needs</p>
      </div>
      <div
        class="scroll-down"
        @click="pageDown()">
        <span class="icon-mouse" />
        <span class="icon-angle-double-down" />
      </div>
      <div
        class="swipe-down"
        @click="pageDown()">
        <span class="icon-one-finger-swipe-up" />
      </div>
    </div>
    <el-container class="lower-shadow intro-section">
      <el-main class="site-inner">
        <el-row :gutter="20">
          <el-col
            :xs="24"
            class="article-bottom-margin">
            <h2>Who We Are!</h2>
            <p>Welcome to Ingalls Image, where it is our mission to make sure your dream become a reality. We are guided by our three principles:</p>
            <p><strong>Dream:</strong> Your dream brought to life. Big or small, a business is, at its core, a dream.
            We do our best to respect this when asked to provide consultation and services. We are here to help your
            dream come to life
            and not to step over it with our own ideas.</p>
            <p><strong>Design:</strong> We work to design what you want, while guiding you on what is currently popular
            and attractive to your customers.
            The world of art is always changing and never faster than it is at this current moment. Let us help you
            keep your image current to attract more
            customers. You continue to know all your business's best practices and standards, and let us keep up to
            date on the world of design.</p>
            <p class="no-margin-bottom"><strong>Do:</strong> Let us do the work for you. Sure we can come in and help
            you get a better understanding on where your media might be
            a little behind, but we can also do the updates for you.</p>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <div class="cta-section">
      <div class="cta-mask" />
      <el-container class="cta-wrapper">
        <el-main class="site-inner">
          <el-card>
            <div slot="header">
              <h2 class="no-margin-bottom">What We Do!</h2>
            </div>
            <el-row
              :gutter="20">
              <el-col
                :xs="24"
                :sm="24"
                :md="8"
                :lg="8"
                :xl="8"
                class="cta-inner">
                <div class="cta-header">
                  <h3>Digital Media
                    <span class="icon-browser icon-right" />
                  </h3>
                </div>
                <div class="cta-body">
                  <p>Need an updated or new website? How about email marketing campaigns? Ingalls Image can provide the
                  services you need to make sure your message reaches all your customers on their phone, tablet, or
                  computer.</p>
                  <router-link
                    :to="{ name: 'digitalMedia.index' }">
                    <el-button
                      plain
                      type="primary">Learn More</el-button>
                  </router-link>
                </div>
              </el-col>

              <el-col
                :xs="24"
                :sm="24"
                :md="8"
                :lg="8"
                :xl="8"
                class="cta-inner">
                <div class="cta-header">
                  <h3>Physical Media
                    <span class="icon-newspaper icon-right" />
                  </h3>
                </div>
                <div class="cta-body">
                  <p>Looking for promotional products, business cards, stationeries or letterheads? We can help you!
                  Ingalls Image works with a range of vendors to make sure we can supply what you need.</p>
                  <router-link
                    :to="{ name: 'physicalMedia.index' }">
                    <el-button
                      plain
                      type="primary">Learn More</el-button>
                  </router-link>
                </div>
              </el-col>

              <el-col
                :xs="24"
                :sm="24"
                :md="8"
                :lg="8"
                :xl="8"
                class="cta-inner">
                <div class="cta-header">
                  <h3>Social Media
                    <span class="icon-global icon-right" />
                  </h3>
                </div>
                <div class="cta-body">
                  <p>Trouble gathering followers? Or just looking to increase your social presence? Ingalls Image can
                  help you strategize and realize your social media hopes.</p>
                  <router-link
                    :to="{ name: 'socialMedia.index' }">
                    <el-button
                      plain
                      type="primary">Learn More</el-button>
                  </router-link>
                </div>
              </el-col>

            </el-row>
          </el-card>
        </el-main>
      </el-container>
    </div>
  </v-layout>
</template>

<script>
/* ============
 * Home Index Page
 * ============
 *
 * The home index page.
 */

import VLayout from '@/layouts/Default.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'HomeIndex',

  metaInfo: {
    title: 'Ingalls Image', // set a title
    titleTemplate: 'Home | %s', // title is now "My Example App - Yay!"
    htmlAttrs: {
      lang: 'en',
      amp: undefined, // "amp" has no value
    },
    meta: [
      { itemprop: 'name', content: 'Home | Ingalls Image' },
      { itemprop: 'description', content: 'Ingalls Image serves as your one stop shop for all your media needs.  Come on in and see what we can do for you today!' },
      { itemprop: 'image', content: 'https://www.ingallsimage.com/img/open-graph/home-page.jpg' },
      { property: 'og:title', content: 'Home | Ingalls Image' },
      { property: 'og:description', content: 'Ingalls Image serves as your one stop shop for all your media needs.  Come on in and see what we can do for you today!' },
      { name: 'description', property: 'description', content: 'Ingalls Image serves as your one stop shop for all your media needs.  Come on in and see what we can do for you today!' },
      { property: 'og:image', content: 'https://www.ingallsimage.com/img/open-graph/home-page.jpg' },
      { property: 'og:url', content: 'https://www.ingallsimage.com/' },
    ],
    link: [
      { rel: 'canonical', href: 'https://www.ingallsimage.com/' },
    ],
  },
  /**
   * The components that the page can use.
   */
  components: {
    VLayout,
  },
  data() {
    return {
      innerHeight: '100px',
      innerWidthSaved: null,
      test: 0,
    };
  },
  mounted() {
    this.$ga.page(this.$router);
    this.calcInnerHeight();
    window.addEventListener('resize', () => {
      this.calcInnerHeight();
    });
  },
  methods: {
    pageDown() {
      window.scroll({ top: window.innerHeight, left: 0, behavior: 'smooth' });
    },
    calcInnerHeight() {
      const innerWidth = window.innerWidth;
      if (!this.innerWidthSaved || this.innerWidthSaved !== innerWidth) {
        if (innerWidth > 768) {
          this.innerHeight = `${window.innerHeight - 70}px`;
        } else {
          this.innerHeight = `${window.innerHeight - 50}px`;
        }
        this.innerWidthSaved = innerWidth;
      }
    },
  },
};
</script>
